import { CountryIconProps } from './types';

const CW = ({ dimension }: CountryIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1046_3603)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#FFDA44"
      />
      <path
        d="M12 24.0007C15.9375 24.0007 19.432 22.1042 21.6201 19.1749H2.37988C4.56801 22.1042 8.06249 24.0007 12 24.0007Z"
        fill="#0052B4"
      />
      <path
        d="M24 12C24 5.37263 18.6274 0 12 0C5.37262 0 0 5.37263 0 12C0 13.419 0.246984 14.7803 0.699188 16.0439H23.3008C23.753 14.7803 24 13.419 24 12Z"
        fill="#0052B4"
      />
      <path
        d="M8.21457 7.69598L8.86205 9.68873H10.9576L9.26232 10.9205L9.9098 12.9134L8.21457 11.6817L6.51934 12.9134L7.16691 10.9205L5.47168 9.68873H7.56708L8.21457 7.69598Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.61541 5.6095L5.00391 6.80519H6.26124L5.2441 7.54422L5.6326 8.73995L4.61541 8.00092L3.59827 8.73995L3.98682 7.54422L2.96973 6.80519H4.22701L4.61541 5.6095Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_3603">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CW;
